import styled from 'styled-components';

import { focusRingOptOutDecl } from 'theme/mixins';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  height: 38px;
  padding: 0 ${({ theme }) => theme.spacing.sm}px;
  background-color: ${({ theme }) => theme.colors.backgroundTertiary};
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const StyledInput = styled.input`
  flex: 1;
  min-width: 0;
  background: none;
  border: none;
  outline: none;
  ${focusRingOptOutDecl}
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.m}px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  /*
   * Numeric fields get tabular figures. The position and size readouts update live while
   * an element is dragged, and proportional digits make the whole field twitch as the
   * glyph widths change. NumberInput is the only caller that sets this inputmode, so the
   * rule selects itself.
   */
  &[inputmode='decimal'] {
    font-variant-numeric: tabular-nums;
  }
`;

export const StyledAffix = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
`;
